import { MenuItem, toast } from "../../vendor/ds-react";
import {
  ContextMenuItem,
  ContextMenuSeparator,
} from "../../vendor/src/features/remotion-editor/editor/context-menu";
import { openImageActions } from "../host/image-actions";
export function ImageActionsContextMenu({ clipId }: { clipId: string }) {
  return (
    <>
      <ContextMenuSeparator />
      <ContextMenuItem
        onPointerDown={(event) => event.stopPropagation()}
        onSelect={() => {
          try {
            openImageActions(clipId);
          } catch {
            toast({
              type: "error",
              description: "편집기 준비 후 다시 시도해 주세요.",
            });
          }
        }}
      >
        <MenuItem
          size="md"
          showLeadingIcon={false}
          text="이미지 수정·교체"
          className="w-full"
        />
      </ContextMenuItem>
    </>
  );
}
